module.exports = __webpack_public_path__ + "static/media/adjust-panel.3a1c036f.png";